import type {
  MemberTrainingStatus,
  TrainingCollaboratorFilters,
  TrainingCollaboratorSearchType,
  TrainingCollaboratorSortField,
} from '@/entities/Training';
import { QUANTITY_OPTIONS } from '@/shared/config';
import { firstQueryValue } from '@/shared/lib';

export const COLLABORATORS_TAB_ID = 'colaboradores';

export const DEFAULT_ITEMS_PER_PAGE = 10;

export const DEFAULT_COLLABORATOR_SEARCH_TYPE: TrainingCollaboratorSearchType = 'collaborator';

export const COLLABORATOR_SEARCH_TYPES: TrainingCollaboratorSearchType[] = [
  'collaborator',
  'registrationNumber',
];

export const COLLABORATOR_SORT_FIELDS: TrainingCollaboratorSortField[] = [
  'name',
  'registrationNumber',
];

export const COLLABORATOR_STATUSES: MemberTrainingStatus[] = [
  'PENDING',
  'COMPLETED',
  'NOT_COMPLETED',
];

// `COLLABORATOR_QUANTITY_OPTIONS` only renames the last entry, so the ids are the shared ones.
export const COLLABORATOR_QUANTITIES = QUANTITY_OPTIONS.map((option) => option.id);

export const parseCollaboratorStatus = (raw: unknown): MemberTrainingStatus | undefined => {
  const value = firstQueryValue(raw);
  return COLLABORATOR_STATUSES.includes(value as MemberTrainingStatus)
    ? (value as MemberTrainingStatus)
    : undefined;
};

export const parseCollaboratorPositionId = (raw: unknown): number | undefined => {
  const value = firstQueryValue(raw);
  if (value === undefined || value.trim() === '') return undefined;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
};

export const parseCollaboratorFilters = (
  query: Record<string, unknown>
): TrainingCollaboratorFilters => ({
  status: parseCollaboratorStatus(query.status),
  positionId: parseCollaboratorPositionId(query.positionId),
});
